import { QueryClientStore } from './query-client.store';

/**
 * @deprecated This class is deprecated and should not be used in new implementations.
 */
export class PageClientPersistStore extends QueryClientStore {
    constructor() {
        super('page');
    }
}
